import './MainDisplay.css'

// Reusable right content shell used inside MainLayout. Optional header row
// above a scrollable body that pages fill with their main content.
function MainDisplay({ header, children }) {
  return (
    <section className="main-display">
      {header != null && <div className="main-display-header">{header}</div>}
      <div className="main-display-body">{children}</div>
    </section>
  )
}

export default MainDisplay
